'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sortBy2 = require('lodash/sortBy');

var _sortBy3 = _interopRequireDefault(_sortBy2);

var _groupBy2 = require('lodash/groupBy');

var _groupBy3 = _interopRequireDefault(_groupBy2);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _models = require('../../models');

var _common = require('../common');

var _commonFormsy = require('../common-formsy');

var _constants = require('../../constants');

var _TermsTable = require('./TermsTable');

var _TermsTable2 = _interopRequireDefault(_TermsTable);

var _LegalFundingLienModalFormGroup = require('./LegalFundingLienModalFormGroup');

var _LegalFundingLienModalFormGroup2 = _interopRequireDefault(_LegalFundingLienModalFormGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var LIEN_ACTIONS = _constants.AppConstants.LIEN_ACTIONS,
    MODAL_TITLE = {
  create: 'Generate Contract',
  edit: 'Edit Contract',
  finalize: 'Finalize Contract',
  revise: 'Revise Contract',
  view: 'Contract Details'
},
    MODAL_BUTTON = {
  create: 'Generate Contract',
  edit: 'Save',
  finalize: 'Finalize',
  revise: 'Save',
  view: 'Close'
},
    UNCATEGORIZED_ORDER = 999;

var LegalFundingLienModal = (_dec = (0, _mobxReact.inject)('CaseStore', 'LienStore', 'PriorFundingStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(LegalFundingLienModal, _Component);

  function LegalFundingLienModal(props) {
    _classCallCheck(this, LegalFundingLienModal);

    var _this = _possibleConstructorReturn(this, (LegalFundingLienModal.__proto__ || Object.getPrototypeOf(LegalFundingLienModal)).call(this, props));

    _initDefineProp(_this, 'loading', _descriptor, _this);

    _initDefineProp(_this, 'submitErrors', _descriptor2, _this);

    _initDefineProp(_this, 'priorFunding', _descriptor3, _this);

    _initDefineProp(_this, 'errorMessage', _descriptor4, _this);

    _initDefineProp(_this, 'lien', _descriptor5, _this);

    _this.presets = [];

    if (!props.lienId) {
      _this.lien = new _models.LienModel();
    }
    return _this;
  }

  _createClass(LegalFundingLienModal, [{
    key: 'fetch',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, _case, application, lienId, LienStore;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, _case = _props._case, application = _props.application, lienId = _props.lienId, LienStore = _props.LienStore;


                this.loading = true;
                _context.next = 4;
                return LienStore.fetchPresets();

              case 4:
                this.presets = _context.sent;

                if (!lienId) {
                  _context.next = 9;
                  break;
                }

                _context.next = 8;
                return LienStore.retrieve(lienId, 'legal-funding', {});

              case 8:
                this.lien = _context.sent;

              case 9:

                if ((0, _get3.default)(application, 'prior_funding')) {
                  this.priorFunding = (0, _find3.default)(_case.prior_fundings, { id: (0, _get3.default)(application, 'prior_funding.id') });
                }

                this.loading = false;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetch() {
        return _ref.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.fetch();
    }
  }, {
    key: 'publishedOrSelectedPresets',
    value: function publishedOrSelectedPresets() {
      var publishedPresets = (this.presets || []).filter(function (p) {
        return p.is_published;
      });
      var grouped = (0, _groupBy3.default)(publishedPresets, function (p) {
        return (0, _get3.default)(p, 'category.id', null);
      });

      var categories = Object.entries(grouped).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            categoryId = _ref3[0],
            templates = _ref3[1];

        var category = (0, _get3.default)(templates, '[0].category');
        return {
          id: categoryId === 'null' ? null : categoryId,
          name: (0, _get3.default)(category, 'name', 'Uncategorized'),
          order: (0, _get3.default)(category, 'order', UNCATEGORIZED_ORDER),
          templates: (0, _sortBy3.default)(templates, 'order')
        };
      });

      return (0, _sortBy3.default)(categories, 'order');
    }
  }, {
    key: 'onFormChange',
    value: function onFormChange(data) {
      if (!this.loading) {
        var model = this.refForm.getModel();
        if (this.lien.preset_contract_template !== model.preset_contract_template) {
          var preset = (0, _find3.default)(this.presets, { id: model.preset_contract_template });
          this.lien.applyPreset(preset);
        }
        this.lien.extend((0, _omit3.default)(model, 'prior_funding'));

        if (model.prior_funding) {
          (0, _mobx.extendObservable)(this.priorFunding, model.prior_funding);
        }
      }
    }
  }, {
    key: 'addBuyout',
    value: function addBuyout() {
      this.priorFunding = {
        buyout_amount: '',
        expiration_date: '',
        funder_name: ''
      };
    }
  }, {
    key: 'onValidSubmit',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(model, resetForm, invalidateForm) {
        var _props2, _case, CaseStore, currentAction, LienStore, PriorFundingStore, UiStore, lienData, lien;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, _case = _props2._case, CaseStore = _props2.CaseStore, currentAction = _props2.currentAction, LienStore = _props2.LienStore, PriorFundingStore = _props2.PriorFundingStore, UiStore = _props2.UiStore;


                this.loading = true;
                this.errorMessage = null;
                this.lien.fees = (0, _mobx.toJS)(this.lien.fees).filter(function (fee) {
                  return fee.fee_type && fee.fee_amount;
                });

                _context2.prev = 4;
                lienData = _extends({}, this.lien.serialize(), currentAction === LIEN_ACTIONS.finalize && { is_confirmed: true });
                _context2.next = 8;
                return LienStore.upsertLegalFundingLien({
                  caseId: _case.id,
                  data: lienData,
                  lienId: this.lien.id
                });

              case 8:
                lien = _context2.sent;

                if (!this.priorFunding) {
                  _context2.next = 13;
                  break;
                }

                this.priorFunding.link_lien = lien.id;
                _context2.next = 13;
                return PriorFundingStore.create(_case, this.priorFunding);

              case 13:

                // Download new contract
                if (![LIEN_ACTIONS.finalize, LIEN_ACTIONS.revise].includes(currentAction)) {
                  CaseStore.onCaseLienContractDownloadClick(lien.contract_download_url, _case.id);
                }
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](4);

                this.errorMessage = 'An error occured saving contract info.';
                return _context2.abrupt('return');

              case 20:

                // Changes the state of ApplicationStatusCell > StatusActions
                if (currentAction === LIEN_ACTIONS.finalize) {
                  UiStore.modals.LegalFundingLien.finalize();
                }

                // Close modal if no errors
                !this.errorMessage && UiStore.modals.LegalFundingLien.close();

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 16]]);
      }));

      function onValidSubmit(_x, _x2, _x3) {
        return _ref4.apply(this, arguments);
      }

      return onValidSubmit;
    }()
  }, {
    key: 'handleSubmitErrorsChange',
    value: function handleSubmitErrorsChange(submitErrors) {
      this.submitErrors = submitErrors;
      this.loading = false;
    }
  }, {
    key: 'setRefForm',
    value: function setRefForm(comp) {
      this.refForm = comp;
    }
  }, {
    key: 'renderBodyLeft',
    value: function renderBodyLeft() {
      var _props3 = this.props,
          application = _props3.application,
          currentAction = _props3.currentAction,
          showOnly = currentAction === LIEN_ACTIONS.view;


      return _react2.default.createElement(_LegalFundingLienModalFormGroup2.default, {
        addBuyout: this.addBuyout,
        application: application,
        currentAction: currentAction,
        errorMessage: this.errorMessage,
        lien: this.lien,
        priorFunding: this.priorFunding,
        publishedOrSelectedPresets: this.publishedOrSelectedPresets,
        showOnly: showOnly
      });
    }
  }, {
    key: 'renderBodyRight',
    value: function renderBodyRight() {
      var terms = this.lien.terms;


      if (!terms || !terms.length) {
        return null;
      }

      return _react2.default.createElement(_TermsTable2.default, { lien: this.lien, presets: this.presets });
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      if (this.loading) {
        return _react2.default.createElement(_common.Loader, { className: 'modal-loader' });
      }

      return _react2.default.createElement(
        _Grid2.default,
        { className: 'col-wrapper', fluid: true },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { className: 'col-left', lg: 5, md: 5, sm: 12, xs: 12 },
            this.renderBodyLeft()
          ),
          _react2.default.createElement(
            _Col2.default,
            { className: 'col-right', lg: 7, md: 7, sm: 12, xs: 12 },
            this.renderBodyRight()
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          currentAction = _props4.currentAction,
          UiStore = _props4.UiStore,
          showOnly = currentAction === LIEN_ACTIONS.view,
          title = MODAL_TITLE[currentAction],
          buttonText = MODAL_BUTTON[currentAction],
          onClose = UiStore.modals.LegalFundingLien.close;


      return _react2.default.createElement(
        _Modal2.default,
        {
          show: true,
          onHide: onClose,
          className: 'modal-caselien right side-modal large two-col' },
        _react2.default.createElement(
          _commonFormsy.Form,
          {
            disabled: showOnly,
            onChange: this.onFormChange,
            onSubmitErrorsChange: this.handleSubmitErrorsChange,
            onValidSubmit: this.onValidSubmit,
            ref: this.setRefForm },
          _react2.default.createElement(
            _Modal2.default.Header,
            { closeButton: true },
            _react2.default.createElement(
              _Modal2.default.Title,
              null,
              title
            )
          ),
          _react2.default.createElement(
            _Modal2.default.Body,
            null,
            this.renderBody()
          ),
          _react2.default.createElement(
            _Modal2.default.Footer,
            null,
            _react2.default.createElement(
              _ButtonToolbar2.default,
              { className: 'pull-right' },
              !showOnly && _react2.default.createElement(
                _Button2.default,
                { onClick: onClose },
                'Cancel'
              ),
              _react2.default.createElement(
                _Button2.default,
                { disabled: this.loading || this.submitErrors, bsStyle: 'primary', type: 'submit' },
                buttonText
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LegalFundingLienModal;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  application: _propTypes2.default.object,
  CaseStore: _propTypes2.default.object.isRequired,
  currentAction: _propTypes2.default.oneOf(Object.keys(LIEN_ACTIONS)).isRequired,
  lienId: _propTypes2.default.string,
  LienStore: _propTypes2.default.object.isRequired,
  PriorFundingStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'loading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'submitErrors', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'priorFunding', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'errorMessage', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'lien', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'onValidSubmit', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onValidSubmit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = LegalFundingLienModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LIEN_ACTIONS, 'LIEN_ACTIONS', '/app/src/components/page-case/LegalFundingLienModal.js');
  reactHotLoader.register(MODAL_TITLE, 'MODAL_TITLE', '/app/src/components/page-case/LegalFundingLienModal.js');
  reactHotLoader.register(MODAL_BUTTON, 'MODAL_BUTTON', '/app/src/components/page-case/LegalFundingLienModal.js');
  reactHotLoader.register(UNCATEGORIZED_ORDER, 'UNCATEGORIZED_ORDER', '/app/src/components/page-case/LegalFundingLienModal.js');
  reactHotLoader.register(LegalFundingLienModal, 'LegalFundingLienModal', '/app/src/components/page-case/LegalFundingLienModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/LegalFundingLienModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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